<header class="agu-app-bar">
    <!-- `.mlead` (P/Member_Hub.html:864-866): a back chevron on a view with a parent, else the AGU mark linking home. -->
    @if (BackLabel) {
        <button type="button" class="agu-app-bar__lead" [attr.aria-label]="BackAriaLabel" (click)="RequestBack()">
            <agu-icon Name="chevron-left" [Size]="22" />
        </button>
    } @else {
        <button type="button" class="agu-app-bar__lead" aria-label="Home" (click)="RequestHome()"><agu-logo [Height]="18" /></button>
    }
    <div class="agu-app-bar__title">{{ Title }}</div>
    @if (ShowSearch) {
        <button type="button" class="agu-app-bar__search" aria-label="Search" (click)="RequestSearch()">
            <agu-icon Name="search" [Size]="21" />
        </button>
    }
    <button type="button" class="agu-app-bar__avatar" aria-label="Open menu" aria-haspopup="dialog" [attr.aria-expanded]="MenuOpen" (click)="RequestAvatar()">
        <span class="agu-app-bar__initials" aria-hidden="true">{{ Initials }}</span>
    </button>
</header>
